import { createAction, props } from '@ngrx/store';
import { UserCertificate } from './../models/certificate.model';

export const setCertificate = createAction(
  '[Certificate] Set Certificate',
  props<UserCertificate>()
);

export const removeCertificate = createAction(
  '[Certificate] Remove Certificate'
);
